import { MModalite, MSatisfaction } from '@argalis-apps/models';

export const satisfactionDefaultList: MModalite.IModalite[] = [
  {
    id: 1,
    libelle: "J'ai été préalablement informé(e) du contenu et des objectifs de la formation."
  },
  {
    id: 2,
    libelle:
      'Je suis satisfait(e) du ou des livrets qui m’ont été remis (aspect général, pertinence des illustrations, aide pour mettre en application mes acquis...).'
  },
  {
    id: 3,
    libelle:
      "Je suis satisfait(e) des supports vidéoprojetés utilisés en formation (aspect général, pertinence, lisibilité, aide à l'apprentissage...)."
  }
];

export const satisfactionDefaulValue: MSatisfaction.ISatisfactionDefaultParms = {
  satisfactionDefault: [
    {
      id_question: 1,
      value: 2
    },
    {
      id_question: 2,
      value: 3
    },
    {
      id_question: 3,
      value: 5
    }
  ],
  already_completed: false
};
export const statisdactionOptionalValue: MSatisfaction.ISatisfactionOptinal[] = [
  {
    id_question: 1,
    value_after: 9,
    value_before: 5
  },
  {
    id_question: 2,
    value_after: 4,
    value_before: 2
  },
  {
    id_question: 3,
    value_after: 4,
    value_before: 1
  }
];

export const updateValue: MSatisfaction.ISatisfactionUpdate = {
  satisfactionCompetance: [],
  satisfactionSatisfaction: [
    {
      id_question: 1,
      value: 1
    },
    {
      id_question: 2,
      value: 1
    },
    {
      id_question: 3,
      value: 1
    },
    {
      id_question: 4,
      value: 1
    },
    {
      id_question: 5,
      value: 1
    },
    {
      id_question: 6,
      value: 1
    },
    {
      id_question: 7,
      value: 1
    },
    {
      id_question: 8,
      value: 1
    },
    {
      id_question: 12,
      value: 1
    },
    {
      id_question: 11,
      value: 1
    },
    {
      id_question: 9,
      value: 1
    },
    {
      id_question: 10,
      value: 1
    }
  ]
};
